import { useState } from "react";
import { Grid, Tabs } from "@mantine/core";
import { TextTab } from "../../model/TextTab";
import UserTable from "./UserTable";
import GroupUserTable from "./GroupUserTable";

const UserView = () => {
  const [activeTab, setActiveTab] = useState<string | null>("Tài khoản");

  let headertext: TextTab[] = [
    { text: "Tài khoản", content: UserTable },
    { text: "Nhóm phê duyệt", content: GroupUserTable },
  ];

  return (
    <Grid>
      <Grid.Col span={{ base: 12 }}>
        <Tabs value={activeTab} onChange={setActiveTab} keepMounted={false}>
          <Tabs.List>
            {headertext.map((item) => (
              <Tabs.Tab value={item.text} key={item.text}>
                {item.text}
              </Tabs.Tab>
            ))}
          </Tabs.List>

          {headertext.map((item) => (
            <Tabs.Panel value={item.text} key={item.text} pt="xs">
              <item.content />
            </Tabs.Panel>
          ))}
        </Tabs>
      </Grid.Col>
    </Grid>
  );
};
export default UserView;
